type UnsavedChangesHandler = () => string | undefined | null | false | void;

function onUnload(handler: () => string | undefined | null | false | void) {
   window.addEventListener('beforeunload', e => {
      const msg = handler();
      if (msg) {
         // e.returnValue is needed for a few popular browsers
         return (e.returnValue = msg);
      }
   });
}

/**
 * Utility for prompting the user to save any unsaved changes before
 * leaving the page.
 */
export const UnsavedChanges = {
   $handlers: null as UnsavedChangesHandler[] | null,

   /**
    * Add a handler that will be called when the user leaves the page. If
    * the handler returns a message, the browser will prompt the user.
    * Otherwise, the user will leave the page normally.
    */
   addHandler(handler: UnsavedChangesHandler): void {
      if (!this.$handlers) {
         // Initialize the list of handlers and check them when the user
         // unloads the page.
         this.$handlers = [];
         onUnload(this.getMessage.bind(this));
      }

      this.$handlers.push(handler);
   },

   /**
    * Checks if any of the handlers currently have an unsaved changes
    * message for the user.
    */
   getMessage(): string | undefined {
      if (this.$handlers) {
         // Return the first truthy message returned.
         return this.$handlers.map(handler => handler()).find(Boolean) as string | undefined;
      }
   },
};

/**
 * Returns a truthy value if the browser would currently prompt the user
 * when attempting to leave the page.
 */
export function hasUnsavedChanges(): boolean {
   return !!UnsavedChanges.getMessage();
}
